import {createContext} from 'react'

/**
 * Overrides the URL used to resolve "current page" matching in
 * {@link usePageMatcher}. In production this stays `undefined` and the hook
 * falls back to `ssrSafeLocation.href`. It exists purely as an injection seam
 * for stories and tests, which need to simulate being on a particular page.
 */
export const CurrentUrlContext = createContext<string | undefined>(undefined)
